export enum AutoExpandType {
    None = "0",
    FirstLevel = "1",
    SecondLevel = "2"
}

export default AutoExpandType;
